import React from "react";

import TopLeftBracket from './../../images/toprightbracket.png'
import GreenLeftBracket from './../../images/greentopleftbracket.png'
import GreenMedal from './../../images/greenmedal.png'
import WorldCollectionImg5 from './../../images/worldcollectionimg5.png'
import WorldCollectionImg6 from './../../images/worldcollectionimg6.png'
import WorldCollectionBullet from './../../images/worldcollectionbullet.png'
import WorldCollectionImg8 from './../../images/worldcollectionimg8.png'
import WorldCollectionImg9 from './../../images/worldcollectionimg9.png'
import WorldCollectionTxt from './../../images/worldcollectiontxt.png'
import WorldCollectionMic from './../../images/worldcollectionmic.png'
import GreenArrow from './../../images/greenarrowdown.png'
import GreenBullet from './../../images/worlcollectiongreenbullet.png'
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function WorldCollectionHybrid() {
            const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
            const [dimensions, setDimensions] = useState({ 
                height: window.innerHeight,
                width: window.innerWidth
              })

            const handleResize = () => {
                // console.log(window.innerWidth)
                setDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
                });
            }

            useEffect(()=>{
                window.addEventListener("resize", handleResize, false);
            },[])

            return (
                <div>
                    {/* ******************************************** */}


                    {/* DESKTOP VIEW */}

        {
            dimensions.width >= 1024 &&
                <div>
                    <div style={{ 
                        backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rxdh9dkmxbizseve6xz5")`, 
                    //  height:'98.25em',
                        // height:'50px',
                        width:'100%',
                        backgroundSize:'cover',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        paddingBottom:'5em',
                        paddingTop:'5em',
                        position:'relative',
                        overflow:'hidden'
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={WorldCollectionTxt} style={{height:'1129px',width:'100px',right:'1em',top:'8em',position:'absolute'}}/>
                        <div style={{marginTop:'7.81em',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',position:'relative',width:'68%'}}>
                            <img src={TopLeftBracket} style={{position:'absolute',left:'-2.5em',top:'-2.5em'}}/>
                        
                            <div className="WCHeaderTxt" style={{color:'black',backgroundColor:'#81FF95',width:'4.5em',paddingLeft:'0.3em'}}>GET PAID</div> 
                            <div className="WCHeaderTxt">WHAT YOU ARE</div> 
                            <div className="WCHeaderTxt">RIGHTFULLY OWED.</div> 


                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                            <div className="WCSecureEarnings">
                                SECURE YOUR EARNINGS WITH
                            </div>
                            <div className="WCTxt">
                            WORLD COLLECTIONS
                            </div>
                        </div>

                        <div className="WCYourMusic">
                            Your music could already be generating income. Ensure you're not missing out on royalties by taking action now.
                        </div>
                        </div>

                        <div style={{display:'flex',marginTop:'19.37em',flexDirection:'row',width:'80%',maxWidth:'48.75em',position:'relative',border:'1px solid rgba(129,255,149,50%)',backgroundColor:'rgba(129, 255, 149, 15%)',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 63%, 82% 100%, 0 100%, 0% 80%, 0 0)'}}>
                        <img src={GreenLeftBracket} style={{position:'absolute'}}/>
                        <div style={{marginTop:'2.18em',marginLeft:'3.43em',width:'24.5em'}}>
                            <img src={GreenMedal}/>
                            <div className="WCTrackingAllRevenue">Tracking all your revenue streams can be complex.</div>
                            <div className="WCWheneverYouWrite">Whenever you write a song that gets used in commercial settings, you earn royalties, anywhere in the world. You might be missing out on these incomes without even realizing it.</div>

                            <div className="WCTxtGreen">WORLD COLLECTIONS</div>
                            <div className="WCStandReady">stand ready to assist you in claiming the royalties you deserve.</div>
                        </div>

                        <img src={WorldCollectionImg6} style={{width:'11.56em',height:'20.375em',marginTop:'7em',marginLeft:'5em'}}/>
                        </div>

                        <img src={GreenArrow} style={{marginTop:'2.9em'}}/>

                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/llj79jvjc63avcqi94y7")`, 
                            //  height:'50.43em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <div className="WCLicensesAreNeeded">
                        Licenses are needed and royalties are owed for musical and the spoken word compositions anytime, anywhere in the world they are played or used.
                        </div>

                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',marginTop:'4em',width:'80%'}}>
                        <div>
                            <div className="WCMusicAndTheSpoken">Music and the Spoken Word Compositions Royalties include :</div>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played on Pandora, Sirius XM, or other digital or AM/FM radio</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Streamed on Spotify, Apple, Amazon, YouTube Music, or other streaming services</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Streamed on video services such as YouTube, TikTok, or other video sites</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played in a restaurant, bar, gym, or elevator</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played at a live gig</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Appear in a tv show, film, video game, or app</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Put onto a CD, vinyl, cassette, or other physical format</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Has the lyrics available to read on a website or in print</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Is turned into sheet music or guitar tabs</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Is covered and released by another artist</div>
                            </div>
                            <div className="LicenseBulletPoint" style={{marginLeft:'1.1em'}}>And more...</div>
                        </div>

                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cm5pzjo0rjt0lovgxea8"} style={{height:'29.125em',width:'18.75em'}}/>
                        </div>
                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cklfdev0af64ot0fxz6r")`, 
                            //  height:'20.18em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                justifyContent:'center',
                                paddingBottom:'5.4em',
                                paddingTop:'5.4em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <span className="WCWillDirect">
                        <span className="WCWillDirectRainbow">World Collections</span> will direct license and collect royalties for all uses, protect and collect what’s yours.
                        </span>
                        </div>

                        <div style={{ 
                                backgroundImage:`url(${WorldCollectionImg8})`, 
                            //  height:'34.33em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                backgroundPosition:'center',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em',
                            //  backgroundPositionX:'-10px',
                                backgroundRepeat:'no-repeat',
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                            <div className="SimplifiedRoyalty">Simplified Royalty Collection</div>
                            <div className="OurSeamlessTech">Our seamless tech and expert team ensure every version of your song is found and paid for. We correct inaccuracies and reclaim lost earnings, providing a revolutionary service for creators.</div>

                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'flex-start',backgroundColor:'rgba(255,255,255,5%)',paddingTop:'1.5em',paddingBottom:'2em',marginTop:'2em'}}>
                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We cut out middlemen</div>
                                    <div className="RCInfo">We license directly and collect from digital services, ensuring your songs are accurately represented while cutting out middlemen.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We find all the sound<br/> recordings</div>
                                    <div className="RCInfo">Our tech and experts find every version of your songs, ensuring payment by filling missing data. A unique, unmatched service.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We make sure you get paid</div>
                                    <div className="RCInfo">Our advanced technology and team ensure your songs' details are correct for accurate royalty and stream count payments. We also fix discrepancies and recover missing funds.</div>
                                </div>
                            </div>
                        </div>

                        <div className="SlidingContainer" style={{position:'relative'}}>

                            <div className="SlidingBackground"
                            style={{ 
                                    backgroundImage:`url(${WorldCollectionImg9})`, 
                                    // height:'30.62em',
                                    // height:'50px',
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                }}>
                                
                                
                            </div>

                            <span className="WeWorkFor" style={{position:'absolute',top:'5em',width:'100%',zIndex:'10'}}>
                                    WE WORK FOR <span style={{color:'#81FF95',backgroundColor:'rgba(0,0,0,50%)',paddingLeft:'0.25em',paddingRight:'0.25em'}}>LEADING ARTISTS</span>
                            </span>

                        </div>
                    </div>
                }


            {/* ******************************************** */}


            {/* TABLET VIEW */}

        {
            dimensions.width >= 768 && dimensions.width <1024 && 
                <div>
                    <div style={{ 
                        backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rxdh9dkmxbizseve6xz5")`, 
                    //  height:'98.25em',
                        // height:'50px',
                        width:'100%',
                        backgroundSize:'cover',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        paddingBottom:'5em',
                        paddingTop:'5em',
                        position:'relative',
                        overflow:'hidden'
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={WorldCollectionTxt} style={{height:'1129px',width:'100px',right:'1em',top:'8em',position:'absolute'}}/>
                        <div style={{marginTop:'7.81em',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',position:'relative',width:'68%'}}>
                            <img src={TopLeftBracket} style={{position:'absolute',left:'-2.5em',top:'-2.5em'}}/>
                        
                            <div className="WCHeaderTxt" style={{color:'black',backgroundColor:'#81FF95',width:'4.5em',paddingLeft:'0.3em'}}>GET PAID</div> 
                            <div className="WCHeaderTxt">WHAT YOU ARE</div> 
                            <div className="WCHeaderTxt">RIGHTFULLY OWED.</div> 


                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                            <div className="WCSecureEarnings">
                                SECURE YOUR EARNINGS WITH
                            </div>
                            <div className="WCTxt">
                            WORLD COLLECTIONS
                            </div>
                        </div>

                        <div className="WCYourMusic">
                            Your music could already be generating income. Ensure you're not missing out on royalties by taking action now.
                        </div>
                        </div>

                        <div style={{display:'flex',marginTop:'19.37em',flexDirection:'row',width:'90%',position:'relative',border:'1px solid rgba(129,255,149,50%)',backgroundColor:'rgba(129, 255, 149, 15%)',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 63%, 82% 100%, 0 100%, 0% 80%, 0 0)'}}>
                        <img src={GreenLeftBracket} style={{position:'absolute'}}/>
                        <div style={{marginTop:'2.18em',marginLeft:'3.43em',width:'24.5em'}}>
                            <img src={GreenMedal}/>
                            <div className="WCTrackingAllRevenue">Tracking all your revenue streams can be complex.</div>
                            <div className="WCWheneverYouWrite">Whenever you write a song that gets used in commercial settings, you earn royalties, anywhere in the world. You might be missing out on these incomes without even realizing it.</div>

                            <div className="WCTxtGreen">WORLD COLLECTIONS</div>
                            <div className="WCStandReady">stand ready to assist you in claiming the royalties you deserve.</div>
                        </div>

                        <img src={WorldCollectionImg6} style={{width:'11.56em',height:'20.375em',marginTop:'7em',marginLeft:'2em'}}/>
                        </div>

                        <img src={GreenArrow} style={{marginTop:'2.9em'}}/>

                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/llj79jvjc63avcqi94y7")`, 
                            //  height:'50.43em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <div className="WCLicensesAreNeeded">
                        Licenses are needed and royalties are owed for musical and the spoken word compositions anytime, anywhere in the world they are played or used.
                        </div>

                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',marginTop:'4em',width:'80%'}}>
                        <div>
                            <div className="WCMusicAndTheSpoken">Music and the Spoken Word Compositions Royalties include :</div>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played on Pandora, Sirius XM, or other digital or AM/FM radio</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Streamed on Spotify, Apple, Amazon, YouTube Music, or other streaming services</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Streamed on video services such as YouTube, TikTok, or other video sites</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played in a restaurant, bar, gym, or elevator</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Played at a live gig</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Appear in a tv show, film, video game, or app</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Put onto a CD, vinyl, cassette, or other physical format</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Has the lyrics available to read on a website or in print</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Is turned into sheet music or guitar tabs</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint">Is covered and released by another artist</div>
                            </div>
                            <div className="LicenseBulletPoint" style={{marginLeft:'1.1em'}}>And more...</div>
                        </div>

                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cm5pzjo0rjt0lovgxea8"} style={{height:'29.125em',width:'18.75em'}}/>
                        </div>
                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cklfdev0af64ot0fxz6r")`, 
                            //  height:'20.18em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                justifyContent:'center',
                                paddingBottom:'5.4em',
                                paddingTop:'5.4em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <span className="WCWillDirect">
                        <span className="WCWillDirectRainbow">World Collections</span> will direct license and collect royalties for all uses, protect and collect what’s yours.
                        </span>
                        </div>

                        <div style={{ 
                                backgroundImage:`url(${WorldCollectionImg8})`, 
                            //  height:'34.33em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                backgroundPosition:'center',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em',
                            //  backgroundPositionX:'-10px',
                                backgroundRepeat:'no-repeat',
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                            <div className="SimplifiedRoyalty">Simplified Royalty Collection</div>
                            <div className="OurSeamlessTech">Our seamless tech and expert team ensure every version of your song is found and paid for. We correct inaccuracies and reclaim lost earnings, providing a revolutionary service for creators.</div>

                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'flex-start',backgroundColor:'rgba(255,255,255,5%)',paddingTop:'1.5em',paddingBottom:'2em',marginTop:'2em'}}>
                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We cut out middlemen</div>
                                    <div className="RCInfo">We license directly and collect from digital services, ensuring your songs are accurately represented while cutting out middlemen.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We find all the sound<br/> recordings</div>
                                    <div className="RCInfo">Our tech and experts find every version of your songs, ensuring payment by filling missing data. A unique, unmatched service.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'20%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We make sure you get paid</div>
                                    <div className="RCInfo">Our advanced technology and team ensure your songs' details are correct for accurate royalty and stream count payments. We also fix discrepancies and recover missing funds.</div>
                                </div>
                            </div>
                        </div>

                        <div className="SlidingContainer" style={{position:'relative'}}>

                            <div className="SlidingBackground"
                            style={{ 
                                    backgroundImage:`url(${WorldCollectionImg9})`, 
                                    // height:'30.62em',
                                    // height:'50px',
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                }}>
                                
                                
                            </div>

                            <span className="WeWorkFor" style={{position:'absolute',top:'5em',width:'100%',zIndex:'10'}}>
                                    WE WORK FOR <span style={{color:'#81FF95',backgroundColor:'rgba(0,0,0,50%)',paddingLeft:'0.25em',paddingRight:'0.25em'}}>LEADING ARTISTS</span>
                            </span>

                        </div>
                    </div>
                }

            {/* ******************************************** */}


            {/* MOBILE VIEW */}

        {
            dimensions.width < 768 &&
                <div>
                    <div style={{ 
                        backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rxdh9dkmxbizseve6xz5")`, 
                    //  height:'98.25em',
                        // height:'50px',
                        width:'100%',
                        backgroundSize:'cover',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        paddingBottom:'5em',
                        paddingTop:'5em',
                        position:'relative',
                        overflow:'hidden'
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={WorldCollectionTxt} style={{height:'1129px',width:'100px',right:'1em',top:'8em',position:'absolute'}}/>
                        <div style={{marginTop:'7.81em',display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',position:'relative',width:'68%'}}>
                            <img src={TopLeftBracket} style={{position:'absolute',left:'-2.5em',top:'-2.5em'}}/>
                        
                            <div className="WCHeaderTxt" style={{color:'black',backgroundColor:'#81FF95',width:'4.5em',paddingLeft:'0.3em'}}>GET PAID</div> 
                            <div className="WCHeaderTxt">WHAT YOU ARE</div> 
                            <div className="WCHeaderTxt">RIGHTFULLY OWED.</div> 


                        <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                            <div className="WCSecureEarnings">
                                SECURE YOUR EARNINGS WITH
                            </div>
                            <div className="WCTxt">
                            WORLD COLLECTIONS
                            </div>
                        </div>

                        <div className="WCYourMusic">
                            Your music could already be generating income. Ensure you're not missing out on royalties by taking action now.
                        </div>
                        </div>

                        <div style={{display:'flex',marginTop:'19.37em',flexDirection:'row',width:'95%',position:'relative',border:'1px solid rgba(129,255,149,50%)',backgroundColor:'rgba(129, 255, 149, 15%)',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 63%, 82% 100%, 0 100%, 0% 80%, 0 0)'}}>
                        <img src={GreenLeftBracket} style={{position:'absolute'}}/>
                        <div style={{marginTop:'2.18em',marginLeft:'1.43em',width:'24.5em'}}>
                            <img src={GreenMedal}/>
                            <div className="WCTrackingAllRevenue">Tracking all your revenue streams can be complex.</div>
                            <div className="WCWheneverYouWrite">Whenever you write a song that gets used in commercial settings, you earn royalties, anywhere in the world. You might be missing out on these incomes without even realizing it.</div>

                            <div className="WCTxtGreen">WORLD COLLECTIONS</div>
                            <div className="WCStandReady">stand ready to assist you in claiming the royalties you deserve.</div>
                        </div>

                        <img src={WorldCollectionImg6} style={{width:'35%',height:'17em',marginTop:'7em',marginLeft:'0.5em',marginRight:'0.5em'}}/>
                        </div>

                        <img src={GreenArrow} style={{marginTop:'2.9em'}}/>

                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/llj79jvjc63avcqi94y7")`, 
                            //  height:'50.43em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <div className="WCLicensesAreNeeded">
                        Licenses are needed and royalties are owed for musical and the spoken word compositions anytime, anywhere in the world they are played or used.
                        </div>

                        <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cm5pzjo0rjt0lovgxea8"} style={{height:'29.125em',width:'18.75em',marginTop:'1em'}}/>

                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'center',marginTop:'4em',width:'85%'}}>
                        
                            <div className="WCMusicAndTheSpoken" style={{width:'100%',marginLeft:'0em'}}>Music and the Spoken Word Compositions Royalties include:</div>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-start'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Played on Pandora, Sirius XM, or other digital or AM/FM radio</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Streamed on Spotify, Apple, Amazon, YouTube Music, or other streaming services</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Streamed on video services such as YouTube, TikTok, or other video sites</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Played in a restaurant, bar, gym, or elevator</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Played at a live gig</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Appear in a tv show, film, video game, or app</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Put onto a CD, vinyl, cassette, or other physical format</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Has the lyrics available to read on a website or in print</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Is turned into sheet music or guitar tabs</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.4em'}}>
                                <img src={WorldCollectionBullet} style={{width:'0.8em',height:'0.8em'}}/>
                                <div className="LicenseBulletPoint" style={{maxWidth:'100%',marginTop:'0em'}}>Is covered and released by another artist</div>
                            </div>
                            <div className="LicenseBulletPoint" style={{marginLeft:'1.1em'}}>And more...</div>
                       

                      
                        </div>
                        </div>

                        <div style={{ 
                                backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cklfdev0af64ot0fxz6r")`, 
                            //  height:'20.18em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                justifyContent:'center',
                                paddingBottom:'5.4em',
                                paddingTop:'5.4em'
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                        <span className="WCWillDirect" style={{width:'80%'}}>
                        <span className="WCWillDirectRainbow">World Collections</span> will direct license and collect royalties for all uses, protect and collect what’s yours.
                        </span>
                        </div>

                        <div style={{ 
                                backgroundImage:`url(${WorldCollectionImg8})`, 
                            //  height:'34.33em',
                                // height:'50px',
                                width:'100%',
                                backgroundSize:'cover',
                                backgroundPosition:'center',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                paddingBottom:'5em',
                            //  backgroundPositionX:'-10px',
                                backgroundRepeat:'no-repeat',
                                // lineHeight:'0px',
                                // margin:'0px',
                                // padding:'0px',
                                // flex:'1'
                            }}>
                            <div className="SimplifiedRoyalty" style={{alignSelf:'center',textAlign:'center'}}>Simplified Royalty Collection</div>
                            <div className="OurSeamlessTech">Our seamless tech and expert team ensure every version of your song is found and paid for. We correct inaccuracies and reclaim lost earnings, providing a revolutionary service for creators.</div>

                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'flex-start',backgroundColor:'rgba(255,255,255,5%)',paddingTop:'1.5em',paddingBottom:'2em',marginTop:'2em'}}>
                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'30%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We cut out middlemen</div>
                                    <div className="RCInfo">We license directly and collect from digital services, ensuring your songs are accurately represented while cutting out middlemen.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'30%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We find all the sound<br/> recordings</div>
                                    <div className="RCInfo">Our tech and experts find every version of your songs, ensuring payment by filling missing data. A unique, unmatched service.</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'30%'}}>
                                    <img src={GreenBullet}/>
                                    <div className="RCHeader">We make sure you get paid</div>
                                    <div className="RCInfo">Our advanced technology and team ensure your songs' details are correct for accurate royalty and stream count payments. We also fix discrepancies and recover missing funds.</div>
                                </div>
                            </div>
                        </div>

                        <div className="SlidingContainer" style={{position:'relative'}}>

                            <div className="SlidingBackground"
                            style={{ 
                                    backgroundImage:`url(${WorldCollectionImg9})`, 
                                    // height:'30.62em',
                                    // height:'50px',
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                }}>
                                
                                
                            </div>

                            <span className="WeWorkFor" style={{position:'absolute',top:'5em',width:'100%',zIndex:'10'}}>
                                    WE WORK FOR <span style={{color:'#81FF95',backgroundColor:'rgba(0,0,0,50%)',paddingLeft:'0.25em',paddingRight:'0.25em'}}>LEADING ARTISTS</span>
                            </span>

                        </div>
                    </div>
                }


                </div>
            )
}

export default WorldCollectionHybrid;